import type { ChatConfig, Message, UiTexts } from '../../types/chat'
import { detectLocale } from '../../utils/locale'
import { formatTime } from '../../utils/i18n'
import styles from './ChatMessage.module.css'

interface Props {
  message: Message
  config: ChatConfig
  texts: UiTexts
}

export default function ChatMessage({ message, config, texts }: Props) {
  const isUser = message.role === 'user'
  const time = formatTime(message.timestamp, detectLocale(config.locale))
  const rich = !!message.html && (config.allowHTMLInResponses || config.allowMarkdownInResponses)
  // Questions show an avatar only when one is configured (no emoji placeholder).
  const avatarUrl = isUser ? config.userAvatarUrl : config.botAvatarUrl

  return (
    <div className={`${styles.row} ${isUser ? styles.rowUser : styles.rowBot}`} data-part="row" data-role={message.role}>
      {avatarUrl ? (
        <div className={styles.avatar} data-part="row-avatar" aria-hidden="true">
          <img src={avatarUrl} alt="" />
        </div>
      ) : null}

      <div className={styles.bubbleWrapper}>
        <span className="bc-sr-only">{isUser ? texts.you : config.botName}: </span>
        <div
          className={`${styles.bubble} ${isUser ? styles.bubbleUser : styles.bubbleBot}`}
          data-part="bubble"
          {...(rich ? { dangerouslySetInnerHTML: { __html: message.html! } } : {})}
        >
          {rich ? null : message.text}
        </div>
        <span className={styles.time} data-part="time">
          <time dateTime={new Date(message.timestamp).toISOString()}>{time}</time>
        </span>
      </div>
    </div>
  )
}
